import { createFileRoute } from '@tanstack/react-router';
import Event from 'src/pages/Event';

export const Route = createFileRoute('/calendar')({
  component: Event,
});
